module.exports = __webpack_public_path__ + "img/title-2.66708244.png";